import * as Yup from 'yup';

export const productSchema = Yup.object().shape({
  Id: Yup.string(),
  codigo: Yup.string().default('').required('Campo obrigatório'),
  codigo_fornecedor: Yup.string().default('').required('Campo obrigatório'),
  compatibilidade: Yup.array().of(Yup.string()).default([]),
  estoque_atual: Yup.number().default(0).required('Campo obrigatório'),
  estoque_minimo: Yup.number().default(0).required('Campo obrigatório'),
  imagem: Yup.string().default(''),
  localizacao: Yup.string().default('').required('Campo obrigatório'),
  nome: Yup.string().default('').required('Campo obrigatório'),
  preco: Yup.number().default(0).required('Campo obrigatório'),
  preco_custo: Yup.number().default(0).required('Campo obrigatório'),
  segmento: Yup.array().of(Yup.string()).default([]),
});
